import PropTypes from 'prop-types';
import { Container } from 'theme-ui';
import ContentFaqTopic from '~/components/Content/Faq/Topic';
import { useState } from 'react';

const ContentFaq = ({ section, fromHomePage }) => {
  const [currentQuestion, setCurrentQuestion] = useState('');
  const { media: topics, backgroundColor } = section;
  return (
    <Container
      variant="fullwidth"
      color="primary"
      sx={{
        px: ['2.4rem', '4rem'],
        backgroundColor: backgroundColor ?? 'transparent',
      }}
    >
      <Container
        variant="fullwidth"
        sx={{
          mx: 'auto',
          maxWidth: 'var(--max-width)',
        }}
      >
        {topics?.map((topic) => {
          return (
            <ContentFaqTopic
              key={topic.id}
              setCurrentQuestion={setCurrentQuestion}
              currentQuestion={currentQuestion}
              topic={topic}
              fromHomePage={fromHomePage}
            />
          );
        })}
      </Container>
    </Container>
  );
};

export default ContentFaq;

ContentFaq.propTypes = {
  faq: PropTypes.shape({
    topics: PropTypes.array,
  }),
  page: PropTypes.shape({
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.shape({
          description: PropTypes.string,
        }),
        media: PropTypes.arrayOf(PropTypes.shape({})),
        colorTheme: PropTypes.shape({
          slug: PropTypes.string,
        }),
      })
    ),
  }),
};
